var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 17.5488C0.5 13.9474 0.693626 11.0874 1.19786 8.81857C1.70083 6.55541 2.50618 4.91115 3.70866 3.70866C4.91115 2.50618 6.55541 1.70083 8.81857 1.19786C11.0874 0.693626 13.9474 0.5 17.5488 0.5H30.4512C34.0526 0.5 36.9126 0.693626 39.1814 1.19786C41.4446 1.70083 43.0888 2.50618 44.2913 3.70866C45.4938 4.91115 46.2992 6.55541 46.8021 8.81857C47.3064 11.0874 47.5 13.9474 47.5 17.5488V30.4512C47.5 34.0526 47.3064 36.9126 46.8021 39.1814C46.2992 41.4446 45.4938 43.0888 44.2913 44.2913C43.0888 45.4938 41.4446 46.2992 39.1814 46.8021C36.9126 47.3064 34.0526 47.5 30.4512 47.5H17.5488C13.9474 47.5 11.0874 47.3064 8.81857 46.8021C6.55541 46.2992 4.91115 45.4938 3.70866 44.2913C2.50618 43.0888 1.70083 41.4446 1.19786 39.1814C0.693626 36.9126 0.5 34.0526 0.5 30.4512V17.5488Z",
    fill: "white",
    stroke: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3535_19822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 24C36 17.3726 30.6274 12 24 12C17.3726 12 12 17.3726 12 24C12 29.9895 16.3882 34.954 22.125 35.8542V27.4688H19.0781V24H22.125V21.3563C22.125 18.3488 23.9166 16.6875 26.6576 16.6875C27.9701 16.6875 29.3438 16.9219 29.3438 16.9219V19.875H27.8306C26.34 19.875 25.875 20.8001 25.875 21.75V24H29.2031L28.6711 27.4688H25.875V35.8542C31.6118 34.954 36 29.9895 36 24Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6711 27.4688L29.2031 24H25.875V21.75C25.875 20.801 26.34 19.875 27.8306 19.875H29.3438V16.9219C29.3438 16.9219 27.9705 16.6875 26.6576 16.6875C23.9166 16.6875 22.125 18.3488 22.125 21.3563V24H19.0781V27.4688H22.125V35.8542C23.3674 36.0486 24.6326 36.0486 25.875 35.8542V27.4688H28.6711Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3535_19822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.2f8df3852b1cc3cef1b924f5894308d9.svg";
export { ForwardRef as ReactComponent };